import { render, staticRenderFns } from "./ProfileSkeleton.vue?vue&type=template&id=bc4699ae&scoped=true"
import script from "./ProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./ProfileSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProfileSkeleton.vue?vue&type=style&index=0&id=bc4699ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4699ae",
  null
  
)

export default component.exports